import { get, post, sess_get, sess_post } from '../utils/HttpRequests';
import * as actionTypes from './actionTypes';
import { toast } from "react-toastify";

export const getUserLoginHistory = (params) => dispatch => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');
  return sess_get('admin/console/get-user-login-history', session_token, )
    .then((resp) => {
      dispatch({
        type: actionTypes.USERS_HISTORY,
        payload: resp.data.response
      })
      return Promise.resolve(resp.data.response);
    })
    .catch((err) => {
      // console.log('err', err)
    })
}

export const getLoginHistory = (params) => dispatch => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');

  return  sess_post('admin/console/login-logs', session_token, params)
    .then((resp) => {
      dispatch({
        type: actionTypes.LOGIN_HISTORY,
        payload: resp.data.response
      })
      return Promise.resolve(resp.data.response);
    })
    .catch((err) => {
      // console.log('err', err)
    })
}

export const logoutUser = ( username ,params) => dispatch => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');

  return  sess_post('admin/console/logout-admin', session_token, { username })
    .then(() => {  dispatch(getLoginHistory(params)); })
    .then ((res) => {  toast.success("Logged out user Successfully"); return Promise.resolve(res) })
    .catch((err) => {
      toast.error("Logging Out user failure");
      console.log('err', err)
    })
}

export const logoutUserSession = ( userId )  => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');
  return  sess_post('admin/console/logout-user', session_token, { userId })
  .then(() => {
     toast.success("Logged out successfully");
    return Promise.resolve();
  })
  .catch((err) => {
    toast.error(err?.response?.data?.error?.reason || "Logout user failed");
    // console.log('err', err)
  })
}


export const getConsoleUserLoginHistory = (params) => dispatch => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');
  sess_get('admin/console/get-user-login-history', session_token, params)
    .then((resp) => {
      dispatch({
        type: actionTypes.CONSOLE_USERS_HISTORY,
        payload: resp.data.response
      })
    })
    .catch((err) => {
      console.log('err', err)
    })
}


export const getConsoleUserByNameOrNumber = (params) => dispatch => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');
  sess_get('admin/console/search-consoleuser-phone-name', session_token, params)
    .then((resp) => {
      dispatch({
        type: actionTypes.CONSOLE_USERS_SUGGESTION,
        payload: resp.data.response.data
      })
    })
    .catch((err) => {
      // console.log('err', err)
    })
}

export const getUserByNameOrNumber = (params) => dispatch => {
  const session_token = localStorage.getItem('admin-panel-sessionToken');
  sess_get('admin/console/search-user-vmobile-name', session_token, params)
    .then((resp) => {
      dispatch({
        type: actionTypes.USERS_SUGGESTION,
        payload: resp.data.response.data
      })
    })
    .catch((err) => {
      // console.log('err', err)
    })
}